// extracted by mini-css-extract-plugin
export default {"submitButton":"style_submitButton__jyIDw"};